export default __webpack_public_path__ + "static/media/BelleLovelace.5a8a58ce.png";